const slugify = require('slugify');

function urlForArticle(article) {
  const slug =
    article?.slug?.current ||
    article.title
      .toLowerCase()
      .replace(/[^\w ]+/g, '')
      .replace(/ +/g, '-');

  if (!slug) {
    return;
  }

  return `/articles/${article.category_v3?.slug.current}/${slug}/`;
}

function urlForArticleCategory(category) {
  return `/articles/${category.slug.current}/`;
}

function urlForArticleSearchTag(tag) {
  return `/articles/search/?tag=${tag.name}`;
}

function getTop4Articles(articles) {
  // take top 4 articles from each category
  const refinedArticles = articles.slice(0, 4);

  return [
    ...refinedArticles.filter(({ hero }) => hero === true),
    ...refinedArticles.filter(({ hero }) => !hero),
  ];
}

const generateTitleId = (title) =>
  slugify(title ?? '', { lower: true, strict: true });

module.exports.urlForArticleCategory = urlForArticleCategory;
module.exports.urlForArticleSearchTag = urlForArticleSearchTag;
module.exports.urlForArticle = urlForArticle;
module.exports.getTop4Articles = getTop4Articles;
module.exports.generateTitleId = generateTitleId;
